import { makeApiCall } from "../apiRequest";

export default {
  state: {
    organizationList: [],
  },
  getters: {
    getOrganization: (state) => state.organizationList,
  },
  actions: {
    updateIsMaintenanceActive({ commit }, payload) {
      return makeApiCall(
        `organization/updateIsMaintenanceActive?isMaintenanceActive=${payload.isMaintenanceActive}&organizationId=${payload.organizationId}`,
        `POST`,
        payload
      );
    },
    updateIsPaid({ commit }, payload) {
      return makeApiCall(
        `organization/updateIsPaid?isPaid=${payload.isPaid}&organizationId=${payload.organizationId}`,
        `POST`,
        payload
      );
    },
    updateIsOrganizationActive({ commit }, payload) {
      return makeApiCall(
        `organization/updateIsActive?isActive=${payload.isActive}&organizationId=${payload.organizationId}`,
        `POST`,
        payload
      );
    },
    renewSubscription({ commit }, payload) {
      return makeApiCall(
        `subscriptionPlan/renewSubscription?organizationId=${payload.organizationId}`,
        `POST`,
        payload
      );
    },
    async addOrganization({ commit }, payload) {
      try {
        const response = await makeApiCall(
          `organization/saveOrganizationSuperAdmin`,
          `POST`,
          payload
        );
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async getOrganization({ commit }, payload) {
      const response = await makeApiCall(
        "organization/getAll",
        "POST",
        payload
      );
      if (!response.error) {
        commit("setOrganizationList", response.data.data);
      }
      return response;
    },
    async getTransactions(_, payload) {
      const response = await makeApiCall(
        "organization/getTransactions",
        "POST",
        payload
      );
      return response;
    },
    async getPaymentHistory(_, payload) {
      const response = await makeApiCall(
        "organization/getPaymentHistory",
        "POST",
        payload
      );
      return response;
    },
    async addOrganizationManualPayment(_, payload) {
      const response = await makeApiCall(
        "organization/addOrganizationManualPayment",
        "POST",
        payload
      );
      return response;
    },
    async deleteOrganization({ commit }, payload) {
      try {
        const response = await makeApiCall(
          `organization/delete`,
          `DELETE`,
          payload
        );
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  },
  mutations: {
    setOrganizationList(state, payload) {
      state.organizationList = payload;
    },
  },
};
